import { emptyArray } from 'constants/emptyConst';

const exp = {
  entities: {
    offerPartners: {
      // 2232: {
      //   generalData: {},
      //   addresses: [],
      //   contactData: {},
      // }
    },
    associatedPartners: {
      // 2232-0: [
      //   0: {}
      //
    },
    offerPartnerVerifications: {
      // 2232: {
      //   verifications: []
      // }
    },
    offerPartnerEligibilities: {
      // 2232: {
      //  eligibilities: []
      //}
    },
    offerPartnerKnockoutCriteria: {},
    offerPartnerConsents: {
      // 2232: {
      //   consents: []
      // }
    },
    offerPartnerBankAccounts: {
      // 2232: {
      //   bankAccounts: []
      // }
    },
    offerPartnerShareholders: {},
    offerPartnerContactModes: {},
    offerPartnerAddresses: {},
    offerPartnerProperties: {},
    offerPartnerMonthlyObligations: {
      // 2232: {
      //   monthlyObligations: []
      // }
    },
    offerPartnerActivities: {
      // 2232: {
      //   activityFields: []
      // }
    },
    offerPartnerIncomeTypes: {
      // 2232: {
      //   incomes: []
      // }
    },
    offerPartnerIncomeData: {
      // 2232: {
      //   incomeData: {}
      // }
    },
    decision: {
      financedChart: {
        //1234-0: {}
      }
    },
    documentEntities: {},
    scoring: {
      // 1234-0: {
      //    scoringGrids: [],
      //    scoringResult: {}
      // }
    },
    verifications: {
      // 1234-0: {
      //   verifications:[]
      // }
    },
    scoringHistory: {
      scoringSessions: {
        // 1234-0: {
        //    sessionID1: {},
        //    sessionID2: {}
      },
      scoringSessionsGrids: {
        // sessionID: []
      }
    },
    warranties: {
      //  1234-0: []
    },
    warrantiesSummary: {
      //  1234-0: []
    },
    checklist: {
      //  1234-0: []
    },
    leasingExpenses: {
      //  1234-0: []
    },
    documents: {
      // 1234-0: {
      //    uploadDocuments: [],
      //    availableUploadDocuments: []
      //    exportDocuments: [],
      //    documentPartners: []
      // }
    },
    documentProperties: {
      //  1234-0: []
    },
    commissions: {},
    commissionsDetails: {},
    calculationMethods: {},
    offerPartnerQuestions: {},
    offerPartnerQuestionActions: {},
    responsibleChangeOffers: {},
    responsibleChangeFolders: {},
    contractsForRestructuring: {},
    guarantors: {}
  },
  assetData: {
    assetTypes: Object.assign([], { isLoaded: false }),
    defaultAsset: { isLoaded: false },
    hierarchies: {},
    images: {},
    propertyDetails:{},
    assetHierarchyProperties: {},
    properties: {
      byTypeId: {
        //1:[]
      }
    },
    mandatoryPropertiesConfigured: {
      //assetId_assetTypeId_assetCategory_assetClassification: { properties: [], loading, loaded }
    }
  },
  clientData: {
    partnerTypes: Object.assign([], { isLoaded: false }),
    idTypes: Object.assign([], { isLoaded: false }),
    partnerRoles: Object.assign([], { isLoaded: false }),
    countries: Object.assign([], { isLoaded: false }),
    cities: Object.assign([], { isLoaded: false }),
    citizenships: Object.assign([], { isLoaded: false }),
    relations: Object.assign([], { isLoaded: false }),
    partnerHierarchies: Object.assign([]),
    gdpr: { isLoaded: false },
    defaultAddress: {},
    clients: {
      byUniqueId: {
        //1:{}
      },
      fromPartnerQuery: {}
    },
    counties: {
      byCountryId: {}
    },
    defaultOCRFileExtensions: Object.assign([], { isLoaded: false })
  },
  simulatorData: {
    assets: Object.assign({}, { loaded: false, loading: false, data: Object.assign([]) }),
    products: Object.assign({}, { loaded: false, loading: false, data: Object.assign({}) }),
    saving: false
  },
  currentOffer: {
    header: {
      documentId: null,
      partnerGroupId: null,
      client: {
        partnerId: null,
        partnerTypeCode: null,
        isLoaded: false
      },
      isInvalid: true,
      loading: false
    },
    offerFinancialProductRuleReadOnlyFields: { isLoaded: false, loading: false },
    assetData: {
      assets: Object.assign([], { isLoaded: false }),
      assetsHeader: Object.assign([], { isLoaded: false }),
      inEdit: {
        isLoaded: false,
        asset: {},
        saving: false,
        duplicating: false,
        updatingChassisNumber: false,
        retrievingAssetData: false,
        equipments: {},
        hierarchy: { loaded: false, reload: false },
        secondHandProperties: {}
      },
      deleting: false,
      initializing: false
    },
    assetClientData: {
      client: {
        partnerId: null,
        isLoaded: false,
        loadedByUniqueId: null
      },
      expanded: false,
      printingGdpr: false,
      saving: false
    },
    workflows: Object.assign({}, { isLoaded: false, results: [], tasks: [] }),
    sources: Object.assign([], { isLoaded: false }),
    productSelectionData: {
      flags: {
        viewMode: 0
      },
      products: emptyArray,
      filterData: {}
    },
    offerPartners: Object.assign([], { isLoaded: false }),
    associatedPartners: {},
    financingStructureData: {
      financingStructure: {},
      maxResidualValuePercent: null,
      financingStructureLoaded: false,
      maxResidualValuePercentLoading: false,
      saving: false
    },
    insuranceData: {
      insurance: { products: [] },
      companies: [],
      products: null,
      insuranceLoaded: false,
      companiesLoaded: false,
      productsLoaded: false,
      saving: false
    },
    leasingExpenses: {
      loaded: false,
      loading: false
    },
    feesData: {
      fees: [],
      feesLoaded: false,
      saving: false,
      editable: false,
      feeCatalogLoading: false,
      feeCatalogLoaded: false,
      schemaIsEligibleForNegotiation: false,
      negotiationStatus: null,
      negotiationType: null,
      schemaExchangeRatesLoaded: false,
      schemaExchangeRates: []
    },
    financialDataSummary: {
      loaded: false,
      loading: false
    },
    paymentPlanData: {
      paymentPlan: {},
      isComputed: true,
      isLoaded: false,
      scheduleCellParams: Object.assign({}, { isLoaded: false, loading: false, saving: false }),
      scheduleTypeCellParamTemplates: Object.assign({}, { isLoaded: false, loading: false, saving: false }),
      scheduleTypeParams: { isLoaded: false, typeParams: [] },
      documentScheduleParams: { isLoaded: false, loading: false, saving: false, paramList: [] }
    },
    advanceSplitData: {
      advanceSplit: {
        documentId: null,
        siteId: null,
        advanceSplitIsAmount: false,
        saving: false,
        isDirty: false,
        splitValues: []
      },
      isAdvanceSplitLoaded: false
    },
    warnings: Object.assign([], { isValid: false, loaded: false }),
    financialServicesData: {
      document: {
        header: {},
        services: [],
        categoryServices: []
      },
      serviceUpdates: [],
      wheelSizes: [],
      wheelSizesLoaded: false,
      serviceLinkingList: [],
      serviceLinkingLoaded: false,
      serviceTypesList: [],
      serviceTypesListLoaded: false,
      documentLoaded: false,
      servicesLoading: [],
      saving: false,
      editable: false
    },
    clientData: {
      partners: {
        // [partnerId]: {
        //   partnerId: 4,
        //   isLoaded: false,
        //   loading: false,
        //   expanded: true,
        //   loadedByUniqueId: null
        // }
      },
      temp: {},
      saving: false,
      deleting: false,
      printingGdpr: false,
      waitingForOCR: false
    },
    clientConsentData: {
      consents: {
        // [partnerId]: {
        //   partnerId: 4,
        //   isLoaded: false
        // }
      }
    },
    clientBankAccountData: {
      bankAccounts: {
        // [partnerId]: {
        //   partnerId: 4,
        //   isLoaded: false
        // }
      }
    },
    clientShareholdersData: {
      shareholders: {}
    },
    clientAddressesData: {},
    clientPropertiesData: {},
    clientVerificationsData: {
      verifications: {
        // [partnerId]: {
        //   partnerId: 4,
        //   isLoaded: false
        // }
      }
    },
    clientIncomeTypesData: {
      incomeTypes: {
        // [partnerId]: {
        //   partnerId: 4,
        //   isLoaded: false,
        //   loading: {}
        // }
      }
    },
    partnerEligibilityData: {
      partnerEligibility: {
        //[partnerId]: {
        //  partnerId: 3
        //  isLoaded: false
        //}
      }
    },
    partnerKnockoutCriteria: {
      knockoutCriteria: {}
    },
    clientContactPersonsData: {},
    clientContactModesData: {},
    clientIncomeData: {
      incomeData: {
        // [PartnerId_IncomeTypeId]: {
        //   isLoaded: false
        //   isValid: false
        // }
      }
    },
    clientMonthlyObligationsData: {
      monthlyObligations: {
        // [partnerId]: {
        //   partnerId: 4,
        //   isLoaded: false
        // }
      }
    },
    clientActivityFieldsData: {
      // [partnerId]: {
      //   loading: false,
      //   isLoaded: false
      // }
    },
    offerSidebarData: {
      offerSummary: {
        documentId: '',
        siteId: ''
      },
      offerKpi: {
        documentId: '',
        siteId: ''
      },
      sidebarDrawer: null
    },
    nextStates: Object.assign({}, { nextStatesList: [], isLoaded: false }),
    decision: {
      financedAssets: Object.assign([], { isLoaded: false }),
      selectedConditions: Object.assign([], { isLoaded: false }),
      availableConditions: Object.assign([], { isLoaded: false }),
      subsequentConditions: Object.assign([], { isLoaded: false })
    },
    offerReports: Object.assign([], { isLoaded: false }),
    commissions: {},
    calculationMethods: {},
    clientQuestionnaireData: {
      offerPartnerQuestions: {},
      offerPartnerQuestionActions: {}
    },
    documentPartnerRelations: { isLoaded: false, documentPartnerRelations: [] }
  },
  offerConfig: {
    isLoaded: false,
    autoAssetId: 0,
    defaultCountry: { id: 0, name: null },
    defaultPartnerType: {},
    realBeneficiaryPartnerRoleId: 0,
    isAssetPropertyBehaviorConfigs: false
  },
  ajaxCallsInProgress: 0,
  notifications: {
    unreadNotifications: 0,
    totalNotifications: 0,
    enabled: true,
    data: Object.assign([], { isLoaded: false })
  },
  pendingAsyncCommands: [],
  dictionaries: {
    partnerPriorities: { items: [], isLoaded: false },
    currencies: { items: [], isLoaded: false, loading: false },
    leasingExpenseTypes: [],
    states: [],
    offerVisibilityLevels: { items: [], isLoaded: false, loading: false },
    folderVisibilityLevels: { items: [], isLoaded: false, loading: false },
    partnerFileVisibilityLevels: { items: [], isLoaded: false, loading: false },
    responsibles: [],
    dealers: [],
    users: [],
    userPartners: [],
    riskAnalysisTypes: { items: [], isLoaded: false, loading: false },
    priceTypes: { items: [], isLoaded: false, loading: false },
    decisionTypes: { items: [], isLoaded: false, loading: false },
    commentsConfig: { list: [], isLoaded: false },
    bankAccountTypes: { items: [], isLoaded: false, loading: false },
    addressTypes: { items: [], isLoaded: false, loading: false },
    verificationTypes: { items: [], isLoaded: false, loading: false },
    signatureRoles: { items: [], isLoaded: false, loading: false },
    checklists: { items: [], isLoaded: false, loading: false },
    interestTypes: { items: [], isLoaded: false, loading: false },
    genderTypes: { items: [], isLoaded: false, loading: false },
    invoicingExchangeRates: { items: [], isLoaded: false, loading: false },
    referenceInterests: { items: [], isLoaded: false, loading: false },
    acquisitionExchangeRates: { items: [], isLoaded: false, loading: false },
    creditFinancingLines: { items: [], isLoaded: false, loading: false },
    invoicingBankList: { items: [], isLoaded: false, loading: false },
    scheduleTypes: { items: [], isLoaded: false, loading: false },
    financingTypes: { items: [], isLoaded: false },
    offerTypes: [],
    channels: { items: [], isLoaded: false },
    approvalTypes: { items: [], isLoaded: false },
    transactionCategories: { items: [], isLoaded: false },
    legalForms: { items: [], isLoaded: false, loading: false },
    dimensionPeriods: { items: [], isLoaded: false, loading: false },
    scoringCategoryOptions: { items: [], isLoaded: false, loading: false },
    warrantyTypes: { items: [], isLoaded: false, loading: false },
    commissionTypes: { items: [], isLoaded: false, loading: false },
    countries: { items: [], isLoaded: false },
    counties: { items: [], isLoaded: false },
    cities: { items: [], isLoaded: false },
    partnerRoles: { items: [], isLoaded: false, loading: false },
    calculationMethods: [],
    contractTypes: { items: [], isLoaded: false, loading: false },
    assetCategories: { items: [], isLoaded: false, loading: false },
    assetClassifications: { items: [], isLoaded: false, loading: false },
    partnerPositions: { items: [], isLoaded: false, loading: false },
    contactModeTypes: { items: [], isLoaded: false, loading: false }
  },
  tasksData: {
    taskOptions: [],
    clientCategories: [],
    taskTypes: [],
    tasksResponsibles: [],
    taskResponsiblesForSingleTask: [],
    taskStates: [],
    taskStatuses: [],
    documentTasks: [], // document tasks
    tasks: {}, //daskboard tasks
    tasksIsChanged: false,
    documentTasksIsLoaded: false,
    tasksLoading: false,
    tasksConfig: [],
    tasksConfigIsLoaded: false
  },
  userInfo: Object.assign({}, { isLoaded: false, loading: false }),
  params: Object.assign({}, { loaded: false, loading: false, items: {} }),
  globalRights: Object.assign({}, { loaded: false, loading: false }),
  applicationFeatures: Object.assign({}, { loaded: false, loading: false }),
  documentRights: {},
  dashboard: {
    offerStatsData: {},
    activities: [],
    averageTimeStates: null,
    activeContractChartData: null
  },
  userProfile: {
    userInfo: Object.assign({}, { loaded: false, loading: false }),
    userRights: {
      entities: {},
      list: {}
    },
    userGroups: Object.assign({}, { loaded: false, loading: false })
  },
  snackbar: {
    msg: null,
    type: null
  },
  offerVisible: {
    userPreferences: Object.assign([], { isLoaded: false }),
    selectedUserPreference: {
      isLoaded: false,
      filterName: '',
      implicit: false,
      filters: Object.assign([]),
      fields: Object.assign([])
    },
    defaultUserPreference: {
      isLoaded: false,
      filters: Object.assign([]),
      fields: Object.assign([])
    }
  },
  folderVisible: {
    userPreferences: Object.assign([], { isLoaded: false }),
    selectedUserPreference: {
      isLoaded: false,
      filters: Object.assign([]),
      fields: Object.assign([])
    },
    defaultUserPreference: {
      isLoaded: false,
      filters: Object.assign([]),
      fields: Object.assign([])
    }
  },
  reports: {
    entities: {},
    list: {},
    items: {},
    browserItems: {},
    browserData: {},
    browserDataList: {}
  },
  currentFolder: {
    header: {
      documentId: null,
      client: {
        partnerId: null,
        loaded: false
      },
      riskComment: {
        loaded: false,
        loading: false,
        saving: false
      },
      loaded: false,
      loading: false,
      saving: false
    },
    nextStates: Object.assign([], { isLoaded: false, loading: false }),
    sidebarData: {
      summary: {
        documentId: '',
        siteId: ''
      },
      sidebarDrawer: null
    },
    warnings: Object.assign([], { isValid: false, loaded: false }),
    generalInfo: {
      saving: false,
      loading: false,
      loaded: false
    },
    financedOffers: {
      saving: false,
      loading: false,
      isLoaded: false
    },
    offerPartners: {
      saving: false,
      loading: false,
      isLoaded: false
    },
    clientOffers: {
      saving: false,
      loading: false,
      isLoaded: false
    }
  },
  logsData: {
    logs: {},
    levels: [],
    currentLog: {}
  },
  asset: {
    configurator: {
      hierarchy: { loaded: false },
      data: {},
      equipments: {}
    }
  },
  document: {
    decision: {
      summary: {
        // [id]: {loaded: false, loading: false}
      },
      approvalLevels: {
        // [id]: {loaded: false, loading: false}
      },
      approvalsHistory: {
        // [id]: {loaded: false, loading: false}
      },
      contractGenPermissions: {
        // [id]: {loaded: false, loading: false}
      },
      folderOffers: {},
      financedChart: {},
      approvalTypeDecisionReasons: {}
    },
    scoringData: {
      // [id] : {
      //    scoringGrids: {loaded: false, loading: false, saving: false}
      //    scoringResult: {loaded: false, loading: false}
      //  }
    },
    entities: {},
    guarantors:{},
    scoringHistoryData: {
      // loaded: false
      // loading: false
      // scoringSessionsHistory: []
    },
    warrantyData: {
      warranty: {
        // [id]: {loaded: false, loading: false}
      },
      warrantySummary: {} // summary
    },
    exposure: {
      // [id]: {loaded: false, loading: false, exposureCurrencies:[]}
    },
    verifications: {
      // [id]: {loaded: false, loading: false}
    },
    checklist: {
      // [id]: {loaded: false, loading: false}
    },
    contractGeneration: {
      isLoaded: false,
      loading: false
      //[id]: {isLoaded: false, loading: false}
    },
    leasingContracts: {},
    stateTransitions: {},
    documents: {
      documentSignees: [],
      documentPersons: [],
      documentEntities: {}
    },
    documentProperties: {},
    propertyDetails: {},
  },
  serverEvents: {},
  facilities: {
    entities: {},
    list: {},
    item: {},
    facilityRevolvingTypes: {},
    facilityFlexibilityRules: {},
    facilityCreditLineStatuses: {},
    facilityPurposesForApplication: {},
    facilityPartnerGroups: {},
    facilitySublimits: {},
    facilitySublimitFilters: {},
    facilitySublimitFinancingStructureFilters: {},
    facilityNextStates: {},
    facilityKpiIndicators: {},
    transferFacilityToERPPermissions: {},
    facilityWarranties: {}
  },
  partnerFiles: {
    currentFile: { saving: false },
    item: {},
    partnerFileNextStates: {},
    userPreferences: Object.assign([], { isLoaded: false }),
    selectedUserPreference: {
      isLoaded: false,
      filters: Object.assign([]),
      fields: Object.assign([])
    },
    defaultUserPreference: {
      isLoaded: false,
      filters: Object.assign([]),
      fields: Object.assign([])
    }
  },
  responsibleChangeOffers: {
    list: []
  },
  responsibleChangeFolders: {
    list: []
  },
  genericFilterParams: {
    contexts: {}
  },
  genericFilterOperators: {
    contexts: {}
  },
  genericFilterParamValues: {
    contexts: {}
  },
  dealerBranding: {
    theme: {
      loading: false,
      loaded: false
    }
  }
};

export default exp;
